module.exports = __webpack_public_path__ + "img/p-icon11.17591639.png";